(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  const track = document.querySelector('[data-announcement-track]');
  if (!track) return;

  function initMobileAnimation() {
    if (window.innerWidth >= 750) return;

    setTimeout(() => {
      const slides = Array.from(track.querySelectorAll('.announcement-bar__slide'));
      const gap = parseInt(getComputedStyle(track).gap) || 48;
      
      const halfSlides = slides.slice(0, slides.length / 2);
      let totalWidth = 0;
      
      halfSlides.forEach((slide, index) => {
        totalWidth += slide.offsetWidth;
        if (index < halfSlides.length - 1) {
          totalWidth += gap;
        }
      });

      track.style.setProperty('--total-width', `${totalWidth}px`);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileAnimation);
  } else {
    initMobileAnimation();
  }

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initMobileAnimation, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const updateControlsPosition = () => {
      const sections = document.querySelectorAll('.image-carousel-section');
      sections.forEach(section => {
        const controls = section.querySelector('slideshow-controls[controls-on-media]');
        if (controls) {
          controls.style.setProperty('bottom', '20px', 'important');
          controls.style.setProperty('top', 'auto', 'important');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateControlsPosition);
    } else {
      updateControlsPosition();
    }

    const observer = new MutationObserver(() => {
      updateControlsPosition();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });

    setTimeout(updateControlsPosition, 100);
    setTimeout(updateControlsPosition, 500);
    setTimeout(updateControlsPosition, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class ProductCarousel {
      constructor(container) {
        this.container = container;
        this.track = container.querySelector('[ref="carouselTrack"]');
        this.items = Array.from(container.querySelectorAll('[ref="carouselItems[]"]'));
        this.prevButton = container.querySelector('[ref="prevButton"]');
        this.nextButton = container.querySelector('[ref="nextButton"]');
        this.currentIndex = 0;
        this.itemsPerView = this.getItemsPerView();
        this.maxIndex = Math.max(0, this.items.length - this.itemsPerView);
        this.scrollPosition = 0;

        if (!this.track || this.items.length === 0) return;

        this.init();
      }

      getItemsPerView() {
        if (window.innerWidth < 750) return 2;
        if (window.innerWidth < 990) return 3;
        if (window.innerWidth < 1400) return 4;
        return 5;
      }

      init() {
        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.prev());
          this.nextButton.addEventListener('click', () => this.next());
          this.updateButtons();
        }

        this.track.addEventListener('scroll', () => this.handleScroll());
        window.addEventListener('resize', () => this.handleResize());
        this.initDragToScroll();
        this.handleResize();
      }

      initDragToScroll() {
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasMoved = false;

        this.track.addEventListener('mousedown', (e) => {
          isDown = true;
          hasMoved = false;
          this.track.classList.add('is-dragging');
          this.track.style.cursor = 'grabbing';
          this.track.style.userSelect = 'none';
          startX = e.pageX;
          scrollLeft = this.track.scrollLeft;
        });

        this.track.addEventListener('mouseleave', () => {
          isDown = false;
          this.track.classList.remove('is-dragging');
          this.track.style.cursor = 'grab';
        });

        this.track.addEventListener('mouseup', () => {
          isDown = false;
          this.track.classList.remove('is-dragging');
          this.track.style.cursor = 'grab';
        });

        this.track.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          
          const x = e.pageX;
          const walk = (x - startX) * 1.5;
          
          if (Math.abs(walk) > 5) {
            hasMoved = true;
          }
          
          this.track.scrollLeft = scrollLeft - walk;
        });

        this.track.addEventListener('click', (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        const links = this.track.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', (e) => {
            if (hasMoved) {
              e.preventDefault();
              e.stopPropagation();
            }
          }, true);
        });
      }

      handleScroll() {
        this.updateButtons();
      }

      handleResize() {
        const oldItemsPerView = this.itemsPerView;
        this.itemsPerView = this.getItemsPerView();
        this.maxIndex = Math.max(0, this.items.length - this.itemsPerView);

        if (oldItemsPerView !== this.itemsPerView) {
          this.updateButtons();
        }
      }

      updateButtons() {
        if (!this.prevButton || !this.nextButton) return;

        const scrollLeft = this.track.scrollLeft;
        const scrollWidth = this.track.scrollWidth;
        const clientWidth = this.track.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        this.prevButton.disabled = scrollLeft <= 5;
        this.nextButton.disabled = scrollLeft >= maxScroll - 5;
      }

      prev() {
        if (this.items.length === 0) return;
        
        const scrollLeft = this.track.scrollLeft;
        const trackRect = this.track.getBoundingClientRect();
        const trackLeft = trackRect.left;
        
        let targetItem = null;
        let targetIndex = -1;
        
        for (let i = this.items.length - 1; i >= 0; i--) {
          const item = this.items[i];
          const itemRect = item.getBoundingClientRect();
          const itemLeft = itemRect.left - trackLeft + scrollLeft;
          
          if (itemLeft < scrollLeft - 10) {
            targetItem = item;
            targetIndex = i;
            break;
          }
        }
        
        let targetScrollLeft;
        if (targetIndex === -1) {
          targetScrollLeft = 0;
        } else {
          targetScrollLeft = targetItem.offsetLeft;
        }
        
        this.track.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });

        setTimeout(() => this.updateButtons(), 350);
      }

      next() {
        if (this.items.length === 0) return;
        
        const scrollLeft = this.track.scrollLeft;
        const trackWidth = this.track.clientWidth;
        const scrollWidth = this.track.scrollWidth;
        const maxScroll = Math.max(0, scrollWidth - trackWidth);
        const trackRect = this.track.getBoundingClientRect();
        const trackLeft = trackRect.left;
        const visibleRight = scrollLeft + trackWidth;
        
        let targetItem = null;
        let targetIndex = -1;
        
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          const itemRect = item.getBoundingClientRect();
          const itemLeft = itemRect.left - trackLeft + scrollLeft;
          const itemRight = itemLeft + itemRect.width;
          
          if (itemRight > visibleRight + 10) {
            targetItem = item;
            targetIndex = i;
            break;
          }
        }
        
        let targetScrollLeft;
        if (targetIndex === -1) {
          targetScrollLeft = maxScroll;
        } else {
          const lastItem = this.items[this.items.length - 1];
          if (targetItem === lastItem) {
            targetScrollLeft = maxScroll;
          } else {
            targetScrollLeft = targetItem.offsetLeft;
          }
        }
        
        this.track.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });

        setTimeout(() => this.updateButtons(), 350);
      }

      scrollToIndex() {
        if (this.items.length === 0) return;

        const item = this.items[this.currentIndex];
        if (!item) return;

        const itemLeft = item.offsetLeft;
        const itemWidth = item.offsetWidth;
        const trackWidth = this.track.clientWidth;
        const scrollPosition = itemLeft - (trackWidth - itemWidth) / 2;

        this.track.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });

        requestAnimationFrame(() => this.updateButtons());
      }
    }

    function initCarousels() {
      const containers = document.querySelectorAll('.product-carousel__container');
      containers.forEach(container => {
        if (!container.dataset.carouselInitialized) {
          new ProductCarousel(container);
          container.dataset.carouselInitialized = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else {
      initCarousels();
    }

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', initCarousels);
      document.addEventListener('shopify:section:unload', () => {
        const containers = document.querySelectorAll('.product-carousel__container');
        containers.forEach(container => {
          delete container.dataset.carouselInitialized;
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
